export class CurentSetDevice {
  fport: string;
  data: string;
  arg: number;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/models/curentSetDevice.ts